export default __webpack_public_path__ + "static/media/Segoe-UI-Bold-Italic.04ca0df8.woff";